// extracted by mini-css-extract-plugin
export default {"clinicButton":"ClinicButtons_clinicButton__63mUv"};